import { type FC } from "react";
import { Spinner, Centered } from "@snapchat/snap-design-system";
import styled from "@emotion/styled";

export const CenteredSpinner: FC = () => {
    return (
        <PageCentered>
            <Spinner />
        </PageCentered>
    );
};

const PageCentered = styled(Centered)`
    height: 100vh;
`;
